module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-100italic.woff?f1dcb8253031e839d164463115ce13bd";